export default __webpack_public_path__ + "static/media/background-login.dd5b6834.jpg";